// extracted by mini-css-extract-plugin
export default {"select-group":"select-group___tVSlY","ant-select-selector":"ant-select-selector___ke4u4"};